/**
 * Slick carousel for the related books section
 * in the single-product-book page
 */

jQuery(document).ready(function( $ ) {
  $('.related-products')
    .slick({
      dots:           true,
      infinite:       false,
      speed:          300,
      slidesToShow:   4,
      slidesToScroll: 4,
      responsive:     [
        {
          breakpoint: 1310,
          settings:   {
            slidesToShow:   3,
            slidesToScroll: 3,
            infinite:       false,
            dots:           true
          }
        },
        {
          breakpoint: 768,
          settings:   {
            slidesToShow:   2,
            slidesToScroll: 2,
            infinite:       false
          }
        },
        {
          breakpoint: 480,
          settings:   {
            slidesToShow:   1,
            slidesToScroll: 1,
            infinite:       false
          }
        }
      ]
    });

  // Fix for give the same height for all the elements inside the carousel
  let maxHeight = 0;
  let thisH = 0;
  $('.related-products .product-card')
    .each(function(){
      thisH = $(this).height();
      if (thisH > maxHeight) {
        maxHeight = thisH;
      }
    })
    .height(maxHeight);

  // Fix to the position bug. Move the content of the message to the body
  $('body').append($('.related-products .woocommerce-ajax-message'));
});
